import { Link as RouterLink } from 'react-router-dom';
import {
  Box,
  Container,
  Typography,
  Grid,
  Stack,
  useTheme,
} from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import FaqGrid from '../../components/faq-grid/faq-grid.component';
import { INSURERS } from '../../config/insurers.data';

const SUPPORT_WHATSAPP = 'https://api.whatsapp.com/send?phone=5543996823513';

const Duvidas = () => {
  const theme = useTheme();

  return (
    <Box>
      {/* Hero */}
      <Box sx={{ backgroundColor: theme.palette.text.primary, color: 'white' }}>
        <Container maxWidth="lg" sx={{ py: { xs: 7, md: 10 }, textAlign: 'center' }}>
          <Typography variant="h1" sx={{ fontSize: { xs: '2.2rem', md: '3rem' }, mb: 2 }}>
            Dúvidas frequentes
          </Typography>
          <Typography variant="h4" sx={{ color: theme.palette.grey[100], maxWidth: 680, mx: 'auto' }}>
            Tudo o que você precisa saber sobre seguro viagem e sobre como comprar
            com a Assegurados.
          </Typography>
        </Container>
      </Box>

      {/* Cards das seguradoras */}
      <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
        <Typography variant="h2" sx={{ mb: 1, textAlign: 'center' }}>
          Dúvidas por seguradora
        </Typography>
        <Typography variant="body2" sx={{ textAlign: 'center', mb: 5 }}>
          Conheça cada uma das seguradoras parceiras, suas coberturas e os contatos
          de emergência.
        </Typography>
        <Grid container spacing={3}>
          {INSURERS.map((insurer) => (
            <Grid size={{ xs: 12, md: 4 }} key={insurer.slug}>
              <Box
                component={RouterLink}
                to={`/seguradoras/${insurer.slug}`}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 2,
                  textDecoration: 'none',
                  color: 'inherit',
                  backgroundColor: theme.palette.grey[50],
                  borderRadius: '16px',
                  p: 4,
                  height: '100%',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    boxShadow: '0 12px 30px rgba(2,10,35,0.12)',
                  },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: 'white',
                    borderRadius: '12px',
                    p: 2,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: 72,
                  }}
                >
                  <Box
                    component="img"
                    src={insurer.logo}
                    alt={insurer.name}
                    sx={{ maxHeight: 40, maxWidth: '80%' }}
                  />
                </Box>
                <Typography variant="h3" sx={{ fontSize: '1.35rem' }}>
                  {insurer.name}
                </Typography>
                <Typography variant="body2" sx={{ flexGrow: 1 }}>
                  {insurer.tagline}
                </Typography>
                <Stack direction="row" spacing={0.5} alignItems="center" sx={{ color: theme.palette.primary.main }}>
                  <Typography variant="body1" sx={{ fontWeight: 700 }}>
                    Ver detalhes
                  </Typography>
                  <ArrowForward sx={{ fontSize: 18 }} />
                </Stack>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>

      {/* FAQ geral (mesmo componente da home) */}
      <Box sx={{ backgroundColor: theme.palette.grey[50] }}>
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 } }}>
          <FaqGrid />
        </Container>
      </Box>

      {/* Contato */}
      <Box sx={{ backgroundColor: theme.palette.primary.main, color: 'white' }}>
        <Container maxWidth="lg" sx={{ py: { xs: 6, md: 8 }, textAlign: 'center' }}>
          <Typography variant="h2" sx={{ mb: 2 }}>
            Ainda com dúvidas?
          </Typography>
          <Typography variant="h4" sx={{ mb: 1, opacity: 0.9 }}>
            Fale com a gente pelo WhatsApp — nosso time te ajuda a escolher.
          </Typography>
          <Typography variant="body1" sx={{ mb: 4, opacity: 0.9 }}>
            Atendimento de segunda a sábado, das 08h às 20h.
          </Typography>
          <Box
            component="a"
            href={SUPPORT_WHATSAPP}
            target="_blank"
            rel="noreferrer"
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 1,
              backgroundColor: 'white',
              color: theme.palette.primary.main,
              borderRadius: '999px',
              px: 5,
              py: 1.5,
              textDecoration: 'none',
              fontWeight: 700,
              transition: 'background-color 0.2s ease',
              '&:hover': { backgroundColor: theme.palette.grey[50] },
            }}
          >
            WhatsApp: (43) 99682-3513
            <ArrowForward sx={{ fontSize: 18 }} />
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Duvidas;
